module.exports = __webpack_public_path__ + "img/9-bn.d087056c.png";